import React from "react";
import { renderStrapiContent } from "../utils/contentfulOptions";

const MenuItem = ({ menuItem, category, compact }) => {
  const soldout = menuItem.soldout;
  const name = menuItem.Item_name || "";
  let itemName = name;
  if (category === "Pizza" && name.includes("/")) {
    const [title, detail] = name.split("/");
    itemName = (
      <>
        <span>{title.trim()}</span>
        {detail && (
          <span className="menu-item__name-detail"> / {detail.trim()}</span>
        )}
      </>
    );
  }

  const price = menuItem.item_price
    ? menuItem.item_price
    : menuItem.bottle_price || menuItem.glass_price
    ? `${menuItem.bottle_price || ""}${
        menuItem.bottle_price && menuItem.glass_price ? " / " : ""
      }${menuItem.glass_price || ""}`
    : null;

  const description = menuItem.rich_text_desc
    ? renderStrapiContent(menuItem.rich_text_desc)
    : menuItem.long_description;

  return (
    <article
      className={`menu-item${soldout ? " menu-item--soldout" : ""}${
        compact ? " menu-item--compact" : ""
      }`}
    >
      <div className="menu-item__header">
        <h3 className="menu-item__name">{itemName}</h3>
        <span className="menu-item__price">{soldout ? "sold out" : price}</span>
      </div>
      {menuItem.small_description && (
        <p className="menu-item__note">{menuItem.small_description}</p>
      )}
      {description && <div className="menu-item__desc">{description}</div>}
    </article>
  );
};

export default MenuItem;
